//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { DEFINE_TYPE } from '@/utils/constant';
import messageBox from '@/components/messageBox';

export default {
  name: 'ObjectDrawer',
  components: { messageBox },
  props: {
    formData: {
      type: Object,
      default() {
        return {};
      },
    },
    drawerVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      appOptions: [], // 相关应用
      DefineType: DEFINE_TYPE,
      packageOptions: [], // 包列表
      rules: {
        name: [{ required: true, message: '请输入元数据对象名', trigger: 'blur' }],
        display_name: [{ required: true, message: '请输入业务名称', trigger: 'blur' }],
      },
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList', 'getTenantInfo']),
    defineTypeOption() {
      const DefineType = [];
      Object.keys(this.DefineType).forEach((key) => {
        DefineType.push({
          label: this.DefineType[key],
          value: key,
        });
      });
      if (this.getTenantInfo.tenant_type === 'extend') {
        return DefineType.filter((item) => item.value === 'CUSTOM');
      }
      return DefineType;
    },
  },
  mounted() {
    this.getAppOptions();
    this.getPackageOptions();
  },
  methods: {
    // 获取相关应用列表
    async getAppOptions() {
      await this.$request({
        url: this.$api.getAppList,
        data: { page_size: 999999 },
      }).then((res) => {
        this.appOptions = res.data;
      });
    },
    async getPackageOptions() {
      await this.$request({
        url: this.$api.metaGetPackageList,
        data: {},
      })
        .then((res) => {
          this.packageOptions = res.list;
        })
        .catch(() => {});
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.$message.error('请输入必填项');
          return;
        }
        if (/^[a-zA-Z0-9_]{1,}$/.test(this.formData.name)) {
          this.$emit('handleConfirm');
        } else {
          this.$message.error('元数据对象名允许英文/数字/下划线');
        }
      });
    },
    handleClose() {
      this.$refs.messageBox.show({
        title: '放弃编辑后，本次编辑内容将会丢失，确认放弃？',
        titleIconType: 'warning',
        needCancel: true,
        cancelText: '取消',
        confirmType: 'primary',
        confirmAction: () => {
          this.$refs.messageBox.close();
          this.$emit('handleClose');
        },
      });
    },
  },
};
